const SvgOfflineStatus = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill="#C8C8C8" />
    <path
      d="M10 4.60429L9.39571 4L7 6.39571L4.60429 4L4 4.60429L6.39571 7L4 9.39571L4.60429 10L7 7.60429L9.39571 10L10 9.39571L7.60429 7L10 4.60429Z"
      fill="#757575"
    />
  </svg>
)

export default SvgOfflineStatus
